
































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Money } from 'v-money';

const INPUT_TIMEOUT = 800; // ms

let timeout: any = null;

@Component({
  components: { Money }
})
export default class UiKitInput extends Vue {
  @Prop() public value: any;
  @Prop() public placeholder!: string;
  @Prop() public title?: string;
  @Prop() public name!: string;
  @Prop({ default: 'text' }) public type?: string;
  @Prop() public max?: number;
  @Prop({ default: 0 }) public min?: number;
  @Prop({ default: false }) public withoutTimeout?: boolean;
  @Prop({ default: false }) public currency?: boolean;
  @Prop({ default: () => ({ $error: false }) }) public errors?: object;
  @Prop({ default: () => ({}) }) public errorMessages?: object;

  protected money = {
    decimal: '.',
    thousands: ',',
    prefix: '$',
    suffix: '',
    precision: 0,
    masked: false
  };

  protected input($event: any) {
    const value = this.currency ? $event : $event.target.value;

    const preparedValue = (this.type === 'number') ? parseFloat(value) : value;

    if (preparedValue === this.value) {
      return;
    }

    this.$emit('input', preparedValue);
  }

  protected onChanged(value: any) {
    if (this.withoutTimeout) {
      this.input(value);
    } else {
      clearTimeout(timeout);

      timeout = setTimeout(() => this.input(value), INPUT_TIMEOUT);
    }
  }
}
